module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.integral), function(p) {
    return _c('div', {
      key: p.id,
      staticClass: "card-record"
    }, [_c('div', [(p.status == 0) ? _c('img', {
      attrs: {
        "src": require("../img/auditing.png")
      }
    }) : _c('img', {
      attrs: {
        "src": require("../img/audit.png")
      }
    })]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "top-text"
    }, [_c('span', [_vm._v(_vm._s(p.activity_name))]), _vm._v(" "), (p.status == 0) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#F66B3D"
      }
    }, [_vm._v("审核中")]) : (p.status == 1) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#577CCC"
      }
    }, [_vm._v("已审核通过，请注意查收")]) : (p.status == 2) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#FF5050"
      }
    }, [_vm._v("已驳回，驳回原因请联系工作人员")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "bottom-text"
    }, [_c('span', [_vm._v("兑换数量:  "), _c('span', {
      staticStyle: {
        "color": "#577CCC"
      }
    }, [_vm._v(_vm._s(p.exchange_count))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(p.application_time))])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9496620e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/integral/record.vue
// module id = 1132
// module chunks = 1